export default "__VITE_ASSET__diWU5vVS__"